<template>
  <div class="flex">
    <template v-if="bonusCode && isBonusCodeValid">
      <div class="w-full mr-8 lg:max-w-144">
        <input
          type="text"
          id="bonusCode"
          class="form-control form-control-big"
          disabled
          :value="bonusCode"
        />
      </div>
      <Button
        variant="third"
        size="big-auto"
        :loading="loading"
        :disabled="disabled"
        @click="removeCode"
      >
        {{ __('btn_remove') }}
      </Button>
    </template>
    <template v-else>
      <div class="w-full mr-8 lg:max-w-144">
        <input
          type="text"
          id="bonusCode"
          :placeholder="__('form.coupon_code')"
          class="form-control form-control-big"
          :disabled="disabled"
          v-model="bonusCodeValue"
        />
      </div>
      <Button
        variant="third"
        size="big-auto"
        :disabled="disabled"
        :loading="loading"
        @click="updateCode"
      >
        {{ __('btn_apply_coupon') }}
      </Button>
    </template>
  </div>
  <div
    class="text-red-500 font-bold mt-4"
    v-if="bonusCode && !isBonusCodeValid"
  >
    {{ __('bonus_code_not_found', { code: bonusCode }) }}
  </div>
</template>

<script>
import useBonusCode from '@/stores/BonusCode';
import Button from '@/components/Button';
import { computed, ref } from 'vue';

export default {
  name: 'BonusCode',
  components: {
    Button
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    const {
      getBonusCode,
      updateBonusCode,
      removeBonusCode,
      isBonusCodeValid
    } = useBonusCode();

    const bonusCodeValue = ref(getBonusCode());
    const loading = ref(false);

    const updateCode = async () => {
      loading.value = true;
      await updateBonusCode(bonusCodeValue.value);
      loading.value = false;
    };

    const removeCode = async () => {
      loading.value = true;
      await removeBonusCode();
      bonusCodeValue.value = '';
      loading.value = false;
    };

    return {
      bonusCode: computed(() => getBonusCode()),
      isBonusCodeValid: computed(() => isBonusCodeValid()),
      bonusCodeValue,
      updateCode,
      removeCode,
      loading
    };
  }
};
</script>
